import nls from '../es/Loading.js';
export default {
  ...nls,
  'Wait a minute': 'Espere un momento',
  'Please do not update or reload this screen': 'Por favor, no actualice o recargue esta pantalla.',
};
